// ** React
import { useMemo } from "react";

// ** Redux
import { useSelector } from "react-redux";

// #####################################################

const useProcessedUsersList = ({ usersListData, isAuth }) => {
	const seoContent = useSelector(
		(state) => state.mainPageUsers.seoContent.data
	);
	const seoContentLoading = useSelector(
		(state) => state.mainPageUsers.seoContent.loading
	);
	const seoContentLoaded = useSelector(
		(state) => state.mainPageUsers.seoContent.loaded
	);

	return useMemo(() => {
		if (!usersListData?.length) return [];
		if (isAuth) return usersListData;

		const firstThree = usersListData.slice(0, 3);
		const middleSection = usersListData.slice(3, 10);
		const rest = usersListData.slice(10);

		const seoContentData = seoContent || [];
		// Obiekty content do wstawienia
		const firstContentObject =
			seoContentData.length > 0 && !isAuth
				? { ...seoContentData[0], type: "content" }
				: null;

		const secondContentObject =
			seoContentData.length > 1 && !isAuth
				? { ...seoContentData[1], type: "content" }
				: null;

		return [
			...firstThree,
			firstContentObject,
			...middleSection,
			secondContentObject,
			...rest,
		].filter(Boolean);
	}, [
		usersListData,
		seoContent,
		isAuth,
		seoContentLoading,
		seoContentLoaded,
	]);
};

// #####################################################

export default useProcessedUsersList;

// #####################################################
